<template>
  <div class="data">
    <div class="header">
      <div class="title">数据看板</div>
    </div>
    <div class="part1">
      <el-row type="flex" justify="space-around">
        <el-col :span="6">
          <data-card :card-data="gmv" :first-trade-time="firstTradeTime"></data-card>
        </el-col>
        <el-col :span="6">
          <data-card :card-data="totalTransactions" :first-trade-time="firstTradeTime"></data-card>
        </el-col>
        <el-col :span="6">
          <data-card :card-data="arpa" :first-trade-time="firstTradeTime"></data-card>
        </el-col>
      </el-row>
    </div>
    <div class="part2">
      <tendency-chart :tendency-data="brokenLineChartData"></tendency-chart>
    </div>
    <el-row :gutter="10" type="flex">
      <el-col :xl="12" :lg="17" :md="20" class="channel">
        <div class="part3">
          <channel-chart :channel-data="transChannelData"></channel-chart>
        </div>
      </el-col>
      <!-- <el-col :span="12">
        <div class="part4"></div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import dataCard from "@/views/data-report/components/data-card";
import tendencyChart from "@/views/data-report/components/tendency-chart";
import channelChart from "@/views/data-report/components/channel-chart";
import { getTotalTransaction, getBrokenLineChart, getTransChannelData, getFirstOrderTime } from "@/api/data-report";

export default {
  name: "data-report",
  components: {
    dataCard,
    tendencyChart,
    channelChart
  },

  data() {
    return {
      firstTradeTime: "",
      gmv: {},
      totalTransactions: {},
      arpa: {},
      brokenLineChartData: {},
      transChannelData: {}
    };
  },

  computed: {
    merchantId() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).merchantId;
    }
  },

  mounted() {
    this.getFirstOrderTime();
    this.getTotalTransaction();
    this.getBrokenLineChart();
    this.getTransChannelData();
  },

  methods: {
    async getFirstOrderTime() {
      try {
        const res = await getFirstOrderTime({
          merchantId: this.merchantId
        });
        console.log("🚀 ~ file: index.vue ~ line 79 ~ getFirstOrderTime ~ res", res)
        this.firstTradeTime = res.data.data.firstTradeTime;
      } catch (error) {
        console.log("🚀 ~ file: index.vue ~ line 78 ~ getFirstOrderTime ~ error", error);
      }
    },

    async getTotalTransaction() {
      try {
        const res = await getTotalTransaction({
          merchantId: this.merchantId
        });
        console.log("🚀 ~ file: index.vue ~ line 54 ~ getTotalTransaction ~ res", res);
        this.gmv = {
          title: "总交易额",
          unit: "元",
          amount: (res.data.data.totalAmount / 100).toFixed(2),
          weeksFrom: res.data.data.weekAmountRatio,
          daysFrom: res.data.data.dailyAmountRatio,
          dailyTurnover: (res.data.data.dailyAmount / 100).toFixed(2)
        };
        this.totalTransactions = {
          title: "总交易笔数",
          unit: "笔",
          amount: res.data.data.transNum,
          weeksFrom: res.data.data.weekTransRatio,
          daysFrom: res.data.data.dailyTransRatio,
          dailyTurnover: res.data.data.dailyTransNum
        };
        this.arpa = {
          title: "客单价",
          unit: "元",
          amount: (res.data.data.unitPrice / 100).toFixed(2),
          weeksFrom: res.data.data.weekPriceRatio,
          daysFrom: res.data.data.dailyPriceRatio,
          dailyTurnover: (res.data.data.dailyUnitPrice / 100).toFixed(2)
        };
      } catch (error) {
        console.log("🚀 ~ file: index.vue ~ line 74 ~ getTotalTransaction ~ error", error);
      }
    },

    async getBrokenLineChart(type = 1) {
      try {
        const res = await getBrokenLineChart({
          merchantId: this.merchantId,
          type
        });
        console.log("🚀 ~ file: index.vue ~ line 100 ~ brokenLineChart ~ res", res);
        this.brokenLineChartData = res.data.data;
      } catch (error) {
        console.log("🚀 ~ file: index.vue ~ line 96 ~ brokenLineChart ~ error", error);
      }
    },

    async getTransChannelData(type = 1) {
      try {
        const res = await getTransChannelData({
          merchantId: this.merchantId,
          type
        });
        console.log("🚀 ~ file: index.vue ~ line 127 ~ getTransChannelData ~ res", res);
        this.transChannelData = {
          title: "交易渠道分布",
          ...res.data.data
        };
      } catch (error) {
        console.log("🚀 ~ file: index.vue ~ line 123 ~ transChannelData ~ error", error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.data {
  .header {
    padding-left: 50px;
    background-color: #fff;
    margin-bottom: 30px;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
  }

  .part1 {
    margin-bottom: 30px;

    .el-col {
    }
  }

  .part2,
  .part3,
  .part4 {
    margin: 30px 60px;
    padding: 30px;
    border: 1px solid #f2f2f2;
  }

  .part3,
  .channel {
    // flex: 1;
  }
}
</style>
